module.exports = __webpack_public_path__ + "img/5.e5b20042.jpg";